import { Endpoint } from '@business/api/endpoint';
import { TMProviderInvoiceId, TMProviderInvoiceResponse, BillsInvoiceSearchParams, TMProviderInvoiceDetailedResponse } from '@business/entities/tm/TMProviderInvoiceResponse';
import { R } from '@core/utils/r';
import { ProviderInvoiceFormData } from '@modules/timeMaterials/TimeMaterialOverlay/ProviderInvoiceModal/ProviderInvoiceModal';
import { TMInvoiceScheduleFormData } from '@modules/timeMaterials/TimeMaterialOverlay/Tabs/Order/AddEditTMInvoiceScheduleModal/AddEditTMInvoiceScheduleModal';
import { ProviderBillFormData } from '@modules/vendors/PayablesPage/AddEditProviderBill/ProviderBillForm';
import { BillFormData } from '@modules/vendors/PayablesPage/ViewProviderBill/ViewProviderBillModal';

export function fetchInvoices(data?: BillsInvoiceSearchParams) {
  const params = R.objectCompact(data);
  return Endpoint.get<TMProviderInvoiceResponse[]>(`@gc/provider-invoice`, { params });
}

export function createInvoice(data: ProviderBillFormData) {
  return Endpoint.post<TMProviderInvoiceResponse>(`@gc/provider-invoice`, { data });
}

export function createInvoices(data: ProviderInvoiceFormData) {
  return Endpoint.post<TMProviderInvoiceResponse[]>(`@gc/provider-invoice/invoices`, { data });
}

export function updateInvoice(id: TMProviderInvoiceId, data: TMInvoiceScheduleFormData) {
  return Endpoint.patch<TMProviderInvoiceResponse>(`@gc/provider-invoice/${id}`, { data });
}

export function deleteInvoice(id: TMProviderInvoiceId) {
  return Endpoint.delete<void>(`@gc/provider-invoice/${id}`);
}

export function fetchInvoice(id: TMProviderInvoiceId) {
  return Endpoint.get<TMProviderInvoiceDetailedResponse>(`@gc/provider-invoice/invoice/${id}`);
}

export function syncInvoiceToQBO(id: TMProviderInvoiceId) {
  return Endpoint.post<TMProviderInvoiceResponse>(`@gc/provider-invoice/sync-to-qbo/${id}`);
}

export function reSyncInvoiceToSystem(id: TMProviderInvoiceId) {
  return Endpoint.post<TMProviderInvoiceResponse>(`@gc/provider-invoice/resync-to-system/${id}`);
}

export function fetchAllInvoices() {
  return Endpoint.get<TMProviderInvoiceResponse[]>(`@gc/provider-invoice/all`);
}

export function updateProviderItems(id: TMProviderInvoiceId, data: BillFormData) {
  return Endpoint.patch<TMProviderInvoiceResponse>(`@gc/provider-invoice/items/${id}`, { data });
}